import toast from 'react-hot-toast';
import { predictionEngineLoadMovies } from 'api/prediction-engine';
import { TableRow, LoadDataType } from '../types';
import { LOAD_TABLE_FIELDS } from '../constants/table_fields';
import { createEmptyRow } from './pasteUtils';

export const handleLoadData = async (
  type: LoadDataType,
  tableData: TableRow[],
  setTableData: (data: TableRow[]) => void,
  castRuleVersion: string | null
): Promise<void> => {
  try {
    const movieIds = tableData.map(row => row[LOAD_TABLE_FIELDS.internal_id]).filter(id => id.trim() !== '');
    
    if (movieIds.length === 0) {
      console.warn('No movie IDs found in table');
      return;
    }

    const limited = type === 'Limited';

    const response = await toast.promise(
      predictionEngineLoadMovies({ movieIds, limited, castRuleVersion }),
      {
        loading: 'Loading...',
        success: 'Loaded movies successfully!',
        error: 'Could not load movies.',
      }
    );
    
    if ('error' in response) {
      console.error('Error loading movies:', response.error);
      return;
    }
    
    setTableData(response.movies.map((movie: any) => ({
      ...movie,
      version_id: null,
      is_custom: false,
      plot: movie.plot || movie.script?.name || ''
    }) as TableRow));
  } catch (error) {
    console.error('Failed to load movies:', error);
  }
};
